import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const TeamsListContainer = styled.div`
  padding: 16px 8px;
`;
export const TeamOption = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid ${Variables.colors.complementary_400};
  position: relative;
  & > div:first-child {
    position: absolute;
    width: calc(100% - 8px);
  }
  .checkbox-title {
    padding-right: 36px;
    font-size: ${Variables.font_sizes.x1_medium};
  }
`;
